
const background = () => {
	VANTA.TOPOLOGY({
		el: "#background",
		mouseControls: true,
		touchControls: true,
		minHeight: 200.00,
		minWidth: 200.00,
		scale: 1,
		scaleMobile: 1.00
	  })
}

export default background;